module.exports = __webpack_public_path__ + "img/arrow-sort.b88f8d1.svg";